module.exports = __webpack_public_path__ + "0dcda5d510bc7d164208cde92865dbc0.svg";